import { ChangeEvent, useEffect, useState } from "react";
import { ZodError } from "zod";

export function setPath(data: any, path: string, value: any): any {
    if (!path) {
        return value;
    }

    if (data === null || typeof data !== "object") {
        data = undefined;
    }

    const arrayMatch = path.match(/^\[(\d+)](.*)/);
    if (arrayMatch) {
        const [name, rest] = arrayMatch.slice(1);
        const newData = Array.isArray(data) ? data.slice() : [];
        newData[Number(name)] = setPath(data?.[name], rest, value);
        return newData;
    }

    const objectMatch = path.match(/^\.?(\w+)(.*)/);
    if (objectMatch) {
        const [name, rest] = objectMatch.slice(1);
        return {
            ...data,
            [name]: setPath(data?.[name], rest, value)
        };
    }

    return data;
}

export function getPath(data: any, path: string): any {
    if (!data) {
        return undefined;
    }
    if (!path) {
        return data;
    }

    const match = path.match(/^\[(\d+)](.*)/) ?? path.match(/^\.?(\w+)(.*)/);
    if (match) {
        const [name, rest] = match.slice(1);
        return getPath(data?.[name], rest);
    }
}

interface ChangeEventLike {
    target: {
        name: string;
        value: any;
    }
}

export function useTeaForm({ schema, initialValue }: any = {}) {
    const [value, setValue] = useState(initialValue);
    const [parsed, setParsed] = useState();
    const [errors, setErrors]: any = useState([]);
    const [touched, setTouched] = useState();

    useEffect(() => {
        if (!schema) {
            return;
        }
        try {
            setParsed(schema.parse(value));
            setErrors([]);
        } catch (error) {
            const e = error as ZodError;
            if (e.issues) {
                setErrors(e.issues);
            } else {
                console.error(e);
            }
        }
    }, [value, schema]);

    const handleChange = (event: ChangeEventLike) => {
        setValue(setPath(value, event.target.name, event.target.value));
        setTouched(setPath(touched, event.target.name, true));
    };


    return {
        value,
        parsed,
        errors,
        touched,
        handleChange,
        setValue,
    };
}